import { Component, Input, ViewChild } from '@angular/core';
import { ConfiguracionFirmasTipoFirmantesComponent } from '../../configuracion-firmas/configuracion-firmas-tipo-firmantes/configuracion-firmas-tipo-firmantes.component';

@Component({
  selector: 'app-firma-wizard-inline',
  templateUrl: './firma-wizard-inline.component.html',
  styleUrls: ['./firma-wizard-inline.component.css'],
})
export class FirmaWizardInlineComponent {
  @Input() firmante: any;
  @ViewChild('wizard') wizard?: ConfiguracionFirmasTipoFirmantesComponent;

  getResumenFirma(): string {
    return this.wizard?.getResumenFirma() ?? '';
  }

  iniciarColocacionFirma(): void {
    this.wizard?.iniciarColocacionFirma();
  }
}
